export default {"src":"/_next/static/media/ic_download.af14471d.svg","height":24,"width":25};